import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c197ff2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "full"
}
const _hoisted_2 = {
  key: 1,
  class: "full"
}

import { computed } from "vue";
import { useStore } from "vuex";
import { addSizeToDataLayer } from "@/functions/analytics";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import { Props } from "@/components/ShapeType.vue";
import ValidationMessage from '@/components/UI/ValidationMessage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DropletDimensionInputs',
  props: {
    disabledShapes: {},
    storeShapeGetter: {},
    storeShapeUpdater: {},
    action: {},
    prefix: {},
    isCutout: { type: Boolean },
    modifierAction: {}
  },
  setup(__props: any) {

const store = useStore();
const { isCutout, action, prefix } = __props;

const dimensions = computed(() => store.getters.getMeasurements( 'droplet', isCutout ) );
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const isDimensionValid = computed(() => store.getters.isShapeValid( isCutout ) );
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const message = computed(() => store.getters.getInstructionsForDimension);

const height = computed({
	get: () => dimensions.value.height,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "height",
			value: value,
		});
	},
});

const width = computed({
	get: () => dimensions.value.width,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "width",
			value: value,
		});
	},
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ShapeInputFieldsWrapper, null, {
    default: _withCtx(() => [
      _createVNode(DimensionInput, {
        inputRef: "droplet-width",
        id: `${_ctx.prefix}measurements-droplet-width`,
        name: `${_ctx.prefix}measurements[dimensions][width]`,
        unit: "cm",
        label: dimensionLabel.value('width'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('width'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}droplet-width`),
        onBlur: () => _unref(addSizeToDataLayer)('width', +width.value, 'droplet'),
        modelValue: width.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((width).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"]),
      _createVNode(DimensionInput, {
        inputRef: "droplet-height",
        id: `${_ctx.prefix}measurements-droplet-height`,
        name: `${_ctx.prefix}measurements[dimensions][height]`,
        unit: "cm",
        label: dimensionLabel.value('height'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('height'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}droplet-height`),
        onBlur: () => _unref(addSizeToDataLayer)('height', +height.value, 'droplet'),
        modelValue: height.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((height).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"]),
      (message.value('width', 'height', _ctx.isCutout))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(ValidationMessage, { type: "notice" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(message.value('width', 'height', _ctx.isCutout)), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (message.value('height', 'width', _ctx.isCutout))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(ValidationMessage, { type: "notice" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(message.value('height', 'width', _ctx.isCutout)), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})